import { Paper } from "@mui/material";
import { pick } from "radash";
import { json, useLoaderData } from "react-router-dom";
import { get } from "../apiClient";
import AdvertiserList from "../features/advertisers/AdvertiserList";
import AdvertiserListHeader from "../features/advertisers/AdvertiserListHeader";
import useSearchParamsWithDefaults from "../hooks/useSearchParamsWithDefaults";
import useTitle from "../hooks/useTitle";

const FILTER_PARAMS = ["search", "type"];
const PAGINATION_DEFAULTS = {
  per_page: "25",
  page: "1",
};

const searchParamsToApiParams = (searchParams) => {
  const params = Object.fromEntries(searchParams);

  return {
    ...pick(params, FILTER_PARAMS),
    ...PAGINATION_DEFAULTS,
    ...pick(params, Object.keys(PAGINATION_DEFAULTS)),
  };
};

const loader = async ({ request }) => {
  const params = searchParamsToApiParams(new URL(request.url).searchParams);

  try {
    const {
      data: advertisers,
      pagination: { total_count: totalCount },
    } = await get("player", "/api/v1/advertisers", {
      params: params,
      signal: request.signal,
    });

    return { params, advertisers, totalCount };
  } catch (error) {
    throw json(
      {
        title: "There was an error fetching the advertisers from the server",
        text: " Please try again. If the error is persistent, contact support.",
      },
      { status: error.status }
    );
  }
};

const ADVERTISER_TYPES = [
  { value: "brand_shopper", text: "Brand / Shopper" },
  { value: "publisher", text: "Publisher" },
  { value: "test_internal", text: "N/A (Test / Internal)" },
];

const Advertisers = () => {
  useTitle("Advertisers");
  const { params, advertisers, totalCount } = useLoaderData();
  const filters = pick(params, FILTER_PARAMS);
  const [searchParams, setSearchParams] =
    useSearchParamsWithDefaults(PAGINATION_DEFAULTS);

  return (
    <>
      <Paper elevation={0} square sx={{ px: 2 }}>
        <AdvertiserListHeader
          advertiserTypes={ADVERTISER_TYPES}
          filters={filters}
        />
        <AdvertiserList
          advertisers={advertisers}
          totalCount={totalCount}
          onPageChange={(_event, page) => {
            setSearchParams((prev) => ({
              ...Object.fromEntries(prev),
              page: page + 1,
            }));
          }}
          onRowsPerPageChange={(event) => {
            setSearchParams((prev) => ({
              ...Object.fromEntries(prev),
              per_page: event.target.value,
            }));
          }}
          page={Math.max(Number(searchParams.get("page")) - 1, 0)}
          rowsPerPage={Number(searchParams.get("per_page"))}
        />
      </Paper>
    </>
  );
};

export { loader };

export default Advertisers;
